import { InjectionToken } from '@angular/core';
import { ServicePaymentRepository } from '../contracts/service-payment.repository';

export const SERVICE_PAYMENT_REPOSITORY_TOKEN = new InjectionToken<ServicePaymentRepository>(
  'SERVICE_PAYMENT_REPOSITORY_TOKEN'
);
